import { createReducer, on } from '@ngrx/store';
import {
  PollingData,
  TransactionStatus,
} from '@rd/types/transaction-status.type';
import { PollOrder, PollOrderFail, PollOrderSuccess } from './polling.actions';

export interface PollingState {
  data: {
    [id: string]: PollingData;
  };
}

export const initialState: PollingState = {
  data: {},
};

export const pollingReducer = createReducer(
  initialState,
  on(PollOrder, (state, action) => ({
    ...state,
    data: {
      ...state.data,
      [action.orderId]: {
        status: TransactionStatus.POLLING,
        error: null,
      },
    },
  })),
  on(PollOrderSuccess, (state, action) => ({
    ...state,
    data: {
      ...state.data,
      [action.order.id]: {
        status: TransactionStatus.SUCCESS,
        error: null,
      },
    },
  })),
  on(PollOrderFail, (state, action) => ({
    ...state,
    data: {
      ...state.data,
      [action.orderId]: {
        status: TransactionStatus.FAIL,
        error: action.error,
      },
    },
  })),
);
